// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__rAZ4a","resendInfoText":"OnGoingPaymentBox_resendInfoText__3jWBd"};